<template>
  <div style="background-color:black; height:100vh;">
    <div fill-height fluid class="ma-0">
      <!-- Back Button -->
      <v-btn icon class="back-button" @click="confirmBackNavigation">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <!-- Page Header -->
      <v-row class="pa-7" justify="center">
        <h2 class="red--text">Add Spares</h2>
      </v-row>

      <!-- Form Card -->
      <v-row class="fill-height pa-0 ma-0" justify="center" align="start">
        <v-col cols="12" md="12" class="pa-0">
          <v-card elevation="0" class="add-spares-card">
            <v-card-text>
              <!-- Loading Overlay -->
              <v-overlay :value="loading">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>

              <!-- Form Header -->
              <v-row>
                <h2 class="red--text mx-12" style="margin-bottom: 30px;">SPARES DETAILS</h2>
                <v-spacer></v-spacer>
              </v-row>

              <!-- Spares Form -->
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>
                  <!-- Spares ID (Read-Only) -->
                  <v-col cols="12" md="1">
                    <v-text-field
                      v-model="sparesId"
                      label="Spares ID"
                      dense
                      outlined
                      readonly
                      prepend-inner-icon="mdi-identifier"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>

                  <!-- Status Dropdown -->
                  <v-col cols="12" md="2">
                    <v-select
                      v-model="status"
                      :items="statusOptions"
                      label="Status"
                      outlined
                      dense
                      prepend-inner-icon="mdi-status"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required]"
                      :menu-props="{ maxHeight: '400' }"
                    ></v-select>
                  </v-col>

                  <!-- Journal Number -->
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="journalNumber"
                      label="Journal Number"
                      dense
                      outlined
                      prepend-inner-icon="mdi-file-document"
                      class="pa-0 montserrat-input"
                     
                    ></v-text-field>
                  </v-col>

                  <!-- Journal Credit Number (Visible only if Status is 'Completed') -->
                  <v-col cols="12" md="2" v-if="status === 'Completed'">
                    <v-text-field
                      v-model="journalCreditNumber"
                      label="Journal Credit Number"
                      dense
                      outlined
                      prepend-inner-icon="mdi-file-document-outline"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>

                  <!-- Shipment Number -->
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="shipmentNumber"
                      label="Shipment Number"
                      dense
                      outlined
                      prepend-inner-icon="mdi-truck-delivery"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <!-- Bin Number Dropdown -->
                  <v-col cols="12" md="1">
                    <v-select
                      v-model="binNumber"
                      :items="availableBins"
                      item-text="number"
                      item-value="number"
                      label="Bin"
                      outlined
                      dense
                      prepend-inner-icon="mdi-archive"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required]"
                      :menu-props="{ maxHeight: '400' }"
                    ></v-select>
                  </v-col>

                  <!-- Created Date (Read-Only) -->
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="createdDate"
                      label="Created Date"
                      dense
                      outlined
                      readonly
                      prepend-inner-icon="mdi-calendar-text"
                      class="pa-0 montserrat-input"
                    ></v-text-field>
                  </v-col>

                  <!-- 4 Week Projected Date (Read-Only) -->
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="projectedDate"
                      label="4 Week Projected Date"
                      dense
                      outlined
                      readonly
                      prepend-inner-icon="mdi-calendar"
                      class="pa-0 montserrat-input"
                    ></v-text-field>
                  </v-col>
                  
                  <!-- Free of charge Dropdown -->
                  <v-col cols="12" md="2">
                    <v-select
                      v-model="freeOfCharge"
                      :items="freeOfChargeOptions"
                      label="Free of charge"
                      outlined
                      dense
                      prepend-inner-icon="mdi-tag"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required]"
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <!-- Reason Dropdown -->
                  <v-col cols="10" md="8" class="pa-2">
                    <v-select
                      v-model="reason"
                      :items="reasonOptions"
                      label="Reason"
                      outlined
                      dense
                      prepend-inner-icon="mdi-comment-text-outline"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required]"
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <!-- Quantity -->
                  <v-col cols="12" md="1">
                    <v-text-field
                      v-model="qty"
                      label="Qty"
                      type="number"
                      dense
                      outlined
                      prepend-inner-icon="mdi-numeric"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required, rules.numeric]"
                    ></v-text-field>
                  </v-col>

                  <!-- Code (Smaller Field) -->
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="code"
                      label="Code"
                      dense
                      outlined
                      prepend-inner-icon="mdi-barcode"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>

                  <!-- Description (Smaller Field) -->
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="description"
                      label="Description"
                      dense
                      outlined
                      prepend-inner-icon="mdi-information-outline"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>

                  <!-- Image Upload Button -->
                  <v-col cols="12" md="3" class="d-flex align-center">
                    <v-btn
                      icon
                      color="primary"
                      @click="triggerImageUpload"
                      class="pa-0 montserrat-input"
                      aria-label="Upload Photo"
                    >
                      <v-icon>mdi-camera</v-icon>
                    </v-btn>
                    <!-- Hidden File Input -->
                    <input
                      type="file"
                      accept="image/*"
                      ref="imageInput"
                      @change="handleImageUpload"
                      style="display: none;"
                    />
                    <!-- Display Uploaded Image Thumbnail -->
                    <div v-if="imageUrl" class="ml-2">
                      <v-img
                        :src="imageUrl"
                        max-width="50"
                        max-height="50"
                        contain
                      ></v-img>
                    </div>
                  </v-col>
                </v-row>

                <!-- Comment Text Area -->
                <v-row>
                  <v-col cols="12" md="8" class="pa-2">
                    <v-textarea
                      v-model="comment"
                      label="Comment"
                      outlined
                      dense
                      prepend-inner-icon="mdi-comment"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required]"
                      rows="3"
                      auto-grow
                    ></v-textarea>
                  </v-col>
                </v-row>

                <!-- Save Button -->
                <v-row justify="center">
                  <v-btn
                    dark
                    large
                    width="300px"
                    @click="confirmSubmit"
                    class="montserrat-button pa-0"
                  
                  >
                    <v-icon left>mdi-content-save</v-icon>Save
                  </v-btn>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- Confirmation Dialog -->
    <v-dialog v-model="confirmationDialog.visible" max-width="290">
      <v-card>
        <v-card-title class="headline">{{ confirmationDialog.title }}</v-card-title>
        <v-card-text>{{ confirmationDialog.message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="confirmationDialog.confirm">Yes</v-btn>
          <v-btn color="grey darken-1" text @click="confirmationDialog.visible = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar Notification -->
    <v-snackbar v-model="snackbar" color="success" timeout="3000">
      Spare added successfully!
      <v-btn color="white" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <!-- Error Snackbar Notification -->
    <v-snackbar v-model="errorSnackbar" color="error" timeout="3000">
      {{ errorMessage }}
      <v-btn color="white" text @click="errorSnackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import {
  getFirestore,
  collection,
  addDoc,
  getDocs,
} from "firebase/firestore";
import {
  getStorage,
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import { firebaseApp } from "@/firebaseConfig"; // Adjust the path as needed

const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

export default {
  data() {
    return {
      loading: false,
      valid: false,
      sparesId: "",
      status: "",
      journalNumber: "",
      journalCreditNumber: "",
      shipmentNumber: "",
      freeOfCharge: "",
      binNumber: null,
      createdDate: "",
      projectedDate: "",
      reason: "",
      qty: "",
      code: "",
      description: "",
      imageFile: null,
      imageUrl: "",
      comment: "",
      confirmationDialog: {
        visible: false,
        title: "",
        message: "",
        confirm: null,
      },
      snackbar: false,
      errorSnackbar: false,
      errorMessage: "",
      statusOptions: [
        { text: "Pending", value: "Pending" },
        { text: "Factory Repair", value: "Factory Repair" },
        { text: "Local Repair", value: "Local Repair" },
        { text: "Completed", value: "Completed" },
      ],
      reasonOptions: [
        "Used Parts",
        "Short Supply",
        "Modify parts",
        "Damaged parts",
        "Incorrect Supply",
      ],
      freeOfChargeOptions: [
        { text: "Send F.O.C", value: "Send F.O.C" },
        { text: "Not F.O.C", value: "Not F.O.C" }
      ],
      totalBins: Array.from({ length: 40 }, (_, i) => (i + 1).toString()),
      availableBins: [],
      takenBins: [],
      rules: {
        required: (value) => !!value || "Required.",
        numeric: (value) => {
          if (value === undefined || value === null || value === "") return "Required.";
          return !isNaN(value) || "Must be numeric.";
        },
      },
    };
  },
  watch: {
    status(newStatus) {
      if (newStatus !== "Completed") {
        this.journalCreditNumber = "";
      }
    },
  },
  async created() {
    this.loading = true;
    await this.fetchSpares();
    await this.getSparesId();
    this.createdDate = this.getTodayDate();
    this.projectedDate = this.calculateProjectedDate(this.createdDate);
    this.loading = false;
  },
  methods: {
    async fetchSpares() {
      try {
        const sparesCollection = collection(db, "AwaitingSpares");
        const sparesSnapshot = await getDocs(sparesCollection);

        this.takenBins = sparesSnapshot.docs
          .map((doc) => doc.data())
          .filter((data) => 
            data.binNumber !== null &&
            data.binNumber !== undefined &&
            ["Factory Repair", "Local Repair"].includes(data.status)
          )
          .map((data) => data.binNumber.toString());

        this.availableBins = this.totalBins.filter((bin) => !this.takenBins.includes(bin));

        console.log("Taken Bins:", this.takenBins);
        console.log("Available Bins:", this.availableBins);
      } catch (error) {
        console.error("Error fetching spares:", error);
        this.errorMessage = "Failed to fetch spares.";
        this.errorSnackbar = true;
      }
    },

    async getSparesId() {
      try {
        const sparesCollection = collection(db, "AwaitingSpares");
        const sparesSnapshot = await getDocs(sparesCollection);
        const sparesIds = sparesSnapshot.docs
          .map((doc) => parseInt(doc.data().sparesId, 10))
          .filter((id) => !isNaN(id));
        const highestSparesId = sparesIds.length ? Math.max(...sparesIds) : 0;
        this.sparesId = (highestSparesId + 1).toString();
      } catch (error) {
        console.error("Error fetching sparesId:", error);
        this.sparesId = "1";
        this.errorMessage = "Failed to fetch Spares ID.";
        this.errorSnackbar = true;
      }
    },

    getTodayDate() {
      const today = new Date();
      const yyyy = today.getFullYear();
      let mm = today.getMonth() + 1;
      let dd = today.getDate();
      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;
      return `${yyyy}-${mm}-${dd}`;
    },

    calculateProjectedDate(dateStr) {
      const date = new Date(dateStr);
      date.setDate(date.getDate() + 28);
      const yyyy = date.getFullYear();
      let mm = date.getMonth() + 1;
      let dd = date.getDate();
      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;
      return `${yyyy}-${mm}-${dd}`;
    },

    triggerImageUpload() {
      this.$refs.imageInput.click();
    },

    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.imageFile = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },

    confirmSubmit() {
      this.confirmationDialog = {
        visible: true,
        title: "Confirm Save",
        message: "Are you sure you want to save this spare?",
        confirm: this.submitForm,
      };
    },

    async submitForm() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loading = true;
      try {
        let uploadedImageUrl = "";
        if (this.imageFile) {
          const imageRef = storageRef(
            storage,
            `spares/${this.sparesId}_${Date.now()}_${this.imageFile.name}`
          );
          const snapshot = await uploadBytes(imageRef, this.imageFile);
          uploadedImageUrl = await getDownloadURL(snapshot.ref);
        }
        const spareData = {
          sparesId: this.sparesId.toString(),
          status: this.status,
          journalNumber: this.journalNumber,
          journalCreditNumber: this.status === "Completed" ? this.journalCreditNumber : "",
          shipmentNumber: this.shipmentNumber,
          freeOfCharge: this.freeOfCharge,
          binNumber: this.binNumber ? parseInt(this.binNumber, 10) : null,
          createdDate: this.createdDate,
          projectedDate: this.projectedDate,
          reason: this.reason,
          qty: parseInt(this.qty, 10),
          code: this.code,
          description: this.description,
          imageUrl: uploadedImageUrl,
          comment: this.comment,
        };
        await addDoc(collection(db, "AwaitingSpares"), spareData);
        this.snackbar = true;
        this.$refs.form.reset();
        this.createdDate = this.getTodayDate();
        this.projectedDate = this.calculateProjectedDate(this.createdDate);
        this.sparesId = (parseInt(this.sparesId, 10) + 1).toString();
        this.binNumber = null;
        this.reason = "";
        this.qty = "";
        this.code = "";
        this.description = "";
        this.journalCreditNumber = "";
        this.shipmentNumber = "";
        this.comment = "";
        this.imageFile = null;
        this.imageUrl = "";
        this.freeOfCharge = "";
        await this.fetchSpares();
        // Navigate to /AddSpares after successful save
        this.$router.push('/AddSpares');
      } catch (error) {
        console.error("Error adding spare:", error);
        this.errorMessage = "Failed to add spare. Please try again.";
        this.errorSnackbar = true;
      } finally {
        this.loading = false;
        this.confirmationDialog.visible = false;
      }
    },

    confirmBackNavigation() {
      this.confirmationDialog = {
        visible: true,
        title: "Confirm Navigation",
        message: "Are you sure you want to go back? Unsaved changes will be lost.",
        confirm: this.goBack,
      };
    },

    goBack() {
      this.confirmationDialog.visible = false;
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap");

/* Apply Montserrat Font */
body,
div,
span,
v-card-title,
v-card-text,
v-row,
v-col,
v-card,
v-btn,
v-icon,
v-img,
v-textarea {
  font-family: "Montserrat", sans-serif;
}

/* Card Styling */
.add-spares-card {
  box-shadow: 10px 10px 20px #1b1c1e, -10px -10px 20px #c4242b;
  border-radius: 20px;
  overflow: hidden;
  margin-top: 20px;
  width: 100%;
  padding: 20px;
  transition: all 0.3s ease-in-out;
}

/* Input and Button Styling */
.montserrat-input {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
}

.montserrat-button {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
}

/* Remove Padding */
.pa-0 {
  padding: 0px;
}

/* Back Button Styling */
.back-button {
  color: white;
  border-radius: 50%;
  position: absolute;
  top: 16px;
  left: 16px;
  transition: transform 0.3s ease-in-out;
}

.back-button:hover {
  transform: scale(1.1);
}

.back-button .v-icon {
  color: white;
}

/* Image Upload Button Styling */
.image-upload-btn {
  color: white;
}

/* Adjust the spacing between elements */
.ml-2 {
  margin-left: 8px;
}

/* Image Preview Styling */
.v-img {
  border-radius: 4px;
}

/* Adjust textarea height and margin */
.v-textarea {
  margin-top: 16px;
}
</style>